
function indexDocumentNodes(document) {
  const nodes = new Map();
  const issues = [];
  const visit = (node, path = []) => {
    if (!node || typeof node !== 'object') return;
    const lock = node.attrs?.blockLock;
    const active = lock && (lock.edit || lock.move || lock.remove);
    const id = node.attrs?.lockId;
    if (active && (typeof id !== 'string' || !id)) issues.push({ code: 'lock-identity', severity: 'error', message: 'Every locked block requires a stable lock identifier.' });
    if (id) {
      if (nodes.has(id)) issues.push({ code: 'duplicate-lock-identity', severity: 'error', message: 'Block lock identifiers must be unique.' });
      nodes.set(id, { node, path, lock });
    }
    if (Array.isArray(node.content)) node.content.forEach((child, index) => visit(child, [...path, index]));
  };
  visit(document);
  return { nodes, issues };
}

function lockedNodeValue(node) {
  const attrs = { ...node.attrs };
  delete attrs.blockLock; delete attrs.lockId;
  // Layout locks protect their own settings; child regions retain their own locks.
  return { type: node.type, attrs, ...(!Array.isArray(node.content) || ['container', 'column'].includes(node.type) ? {} : { content: node.content }) };
}

function inspectContentEditorLocks(previous, candidate, { authorLocks = false } = {}) {
  const base = indexDocumentNodes(previous);
  const next = indexDocumentNodes(candidate);
  const issues = [...base.issues, ...next.issues];
  if (authorLocks) return issues;
  for (const [id, current] of base.nodes) {
    if (!current.lock || !(current.lock.edit || current.lock.move || current.lock.remove)) continue;
    const replacement = next.nodes.get(id);
    if (!replacement) {
      if (current.lock.remove) issues.push({ code: 'locked-remove', severity: 'error', message: 'A template-locked block cannot be removed.' });
      continue;
    }
    if (JSON.stringify(replacement.lock) !== JSON.stringify(current.lock)) issues.push({ code: 'locked-policy', severity: 'error', message: 'Template block locks cannot be changed in a publication.' });
    if (current.lock.move && JSON.stringify(replacement.path) !== JSON.stringify(current.path)) issues.push({ code: 'locked-move', severity: 'error', message: 'A template-locked block cannot be moved.' });
    if (current.lock.edit && JSON.stringify(lockedNodeValue(replacement.node)) !== JSON.stringify(lockedNodeValue(current.node))) issues.push({ code: 'locked-edit', severity: 'error', message: 'A template-locked block cannot be edited.' });
  }
  return issues;
}

export { indexDocumentNodes, inspectContentEditorLocks };
